export interface SessionParams {
    key: SessionKeys;
    params: {};
}

export enum SessionKeys {
    TRANSPORTS_TESTS = 'TransportTests',
    RISK_ANALYSIS_TEST = 'testTabFilter',
    EP_TEST = 'epTabFilter'
}
